import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import AuthService from '@/shared/services/AuthService';
import DataCacheService from '@/shared/services/DataCacheService';
import { ProfileQueryKey } from './queryKey';
export var useGetProfile = function () {
    var _a;
    var intl = useIntl();
    var isRealUser = !AuthService.isSupport();
    var _b = useQuery([ProfileQueryKey.Profile], function () {
        return api.base
            .get('/api/employee/profile')
            .then(function (res) { return res.data; });
    }, {
        enabled: isRealUser,
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    }), data = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    if (!isRealUser) {
        var employee = (_a = DataCacheService.getDataCache()) === null || _a === void 0 ? void 0 : _a.employee;
        return { data: employee, isLoading: false, refetch: refetch };
    }
    return { data: data, isLoading: isLoading, refetch: refetch };
};
